const BACK_CAMERA_VIDEO_CONFIG: MediaTrackConstraints = {
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  //@ts-ignore precisamos dessa prop advanced para ajudar no processamento de imagens em dispositivos mais fracos.
  advanced: [{ zoom: 2.0 }],
};

const FRONT_CAMERA_VIDEO_CONFIG: MediaTrackConstraints = {
  facingMode: 'environment',
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  //@ts-ignore precisamos dessa prop advanced para ajudar no processamento de imagens em dispositivos mais fracos.
  advanced: [{ zoom: 3.0 }],
};

const selectBackCamera = (backCameras: MediaDeviceInfo[]) =>
  backCameras.length > 1 ? backCameras[1].deviceId : backCameras[0].deviceId;

export const selectStream = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const videoDevices = devices.filter((device) => device.kind === 'videoinput');

  const backCameras = videoDevices.filter((device) =>
    device.label.toLowerCase().includes('facing back'),
  );

  const hasBackCamera = backCameras.length > 0;

  const stream = await navigator.mediaDevices.getUserMedia({
    video: {
      ...(hasBackCamera ? BACK_CAMERA_VIDEO_CONFIG : FRONT_CAMERA_VIDEO_CONFIG),
      ...(hasBackCamera && {
        deviceId: { exact: selectBackCamera(backCameras) },
      }),
    },
  });

  return stream;
};
